export const FISHING = "fishing"
export const FISHING_UNDERWATER = "fishing_underwater"
export const SWIMMING = "swimming"
export const SURF = "surf"
export const SURF_WIND = "surf_wind"
export const SURF_KITE = "surf_kite"
export const KAYAK = "kayak"
export const SKI_JET = "ski_jet"
export const SKI_WATER = "ski_water"
export const SKI_WAKE = "ski_wake"
export const SNORKELING = "snorkeling"
export const DIVING_SCUBA = "diving_scuba"
export const DIVING_FREE = "diving_free"
export const WALK = "walk"
export const HIKING = "hiking"
export const RIDE = "ride"
export const CYCLING = "cycling"
export const TOURISM = "tourism"
export const READING = "reading"
export const WRITING = "writing"
export const PHOTOGRAPHY = "photography"
export const MUSIC = "music"
export const COOKING = "cooking"
export const ART = "art"
export const GAME_CARD = "game_card"
export const GAME_BOARD = "game_board"
export const GAME_ROLE = "game_role"
export const OTHER = "other"
